import NameOnboarding from './NameOnboarding';

export default NameOnboarding;
